<ng-container *ngIf="component.data$ | async as data">
  <ng-container *ngIf="data.urlLink?.length; else noLink">
    <cx-generic-link [url]="data.urlLink" [target]="data.external ? '_blank' : null">
      <ng-container *ngTemplateOutlet="bannerContent; context: { data: data }"></ng-container>
    </cx-generic-link>
  </ng-container>
  <ng-template #noLink>
    <ng-container *ngTemplateOutlet="bannerContent; context: { data: data }"></ng-container>
  </ng-template>
</ng-container>

<ng-template #bannerContent let-data="data">
  <p class="headline" *ngIf="data.headline" [innerHTML]="data.headline"></p>
  <cx-media loading="lazy" [container]="data.media"></cx-media>
  <p class="content" *ngIf="data.content" [innerHTML]="data.content"></p>
  <h4>{{ data.title }}</h4>
  <span>{{ data.subtitle }}</span>
</ng-template>
